export default __webpack_public_path__ + "static/media/andes_a_la_costa_7.b8e68f04.JPG";